// extracted by mini-css-extract-plugin
export default {"wrapper":"ImageWithPlaceholder_wrapper__bHYEu","shimmer":"ImageWithPlaceholder_shimmer__N8KGi","imgShimmer":"ImageWithPlaceholder_imgShimmer__691EY"};